import { IApplicationState } from '../../types/redux';

export function selectResultsJsonQuery(state: IApplicationState) {
  return state.results.jsonQuery;
}
